import React, {useCallback} from 'react'
import {RouteComponentProps} from '@reach/router'
import {useApi, fetcher} from '../../api/rest'
import {Formik, FormikConfig, FormikHelpers, FormikProps} from 'formik'
import {Container, Loader} from '../layout'
import {Field} from '../form/fields'
import {useAuth} from '../../contexts/UserContext'
import {Building} from 'react-bootstrap-icons'

interface FormValues {
  company_name: string
  company_ssn: string
  message: string
}

interface FormErrors {
  company_name?: string
  company_ssn?: string
  message?: string
}

const reqMsg = 'Þennan reit þarf að fylla út'


function validate({
  company_name,
  company_ssn,
  message,
}: FormValues) {
  const obj: FormErrors = {}

  if (!company_name) {
    obj.company_name = reqMsg
  }

  if (!company_ssn) {
    obj.company_ssn = reqMsg
  }
  else if (company_ssn.length !== 10) {
    obj.company_ssn = 'Kennitala þarf að vera 10 stafir'
  }

  if (!message) {
    obj.message = reqMsg
  }

  return obj
}

export default function CompanyRequestForm(_: RouteComponentProps) {
  const {authToken} = useAuth()

  const {
    data: currentRequests,
    isValidating: currentRequestsLoading,
    revalidate: currentRequestsRevalidate,
  } = useApi('/company-user-requests/', fetcher.get)

  const onSubmit = useCallback(async (
    values: FormValues,
    {resetForm}: FormikHelpers<FormValues>,
    // {setFieldError}: FormikHelpers<FormValues>,
  ) => {
    await fetcher.post('/company-user-requests/', authToken, values)

    // TODO: Catch errors

    currentRequestsRevalidate()
    resetForm()
  }, [authToken, currentRequestsRevalidate])

  const formikProps: FormikConfig<FormValues> = {
    initialValues: {
      company_name: '',
      company_ssn: '',
      message: '',
    },
    onSubmit,
    validate,
  }

  return (
    <>
      {currentRequestsLoading && <Loader />}

      <Container size="lg">
        <div className="row justify-content-center pt-5">
          <div className="col-sm-8 col-xl-5">
            <div className="p-5 bg-white rounded border border-gray">
              <Formik component={Form} {...formikProps} />
            </div>
          </div>
        </div>

        {!!currentRequests?.length && (
          <div className="row justify-content-center py-4">
            <div className="col-sm-8 col-xl-5">
              <div className="px-5 py-4 bg-white rounded border border-gray">
                <h2 className="h4 mb-3">Beiðnir í vinnslu</h2>
                {currentRequests?.map((req: any, i: number) => (
                  <div key={i} className="p-4 mt-3 bg-light border-left border-primary">
                    <div className="mb-2">
                      <h6><strong>{req?.user?.name}</strong></h6>
                    </div>
                    <div>
                      <p className="text-muted mb-0"><small>Fyrirtæki:<strong className="pl-2">{req?.company_name}</strong></small></p>
                    </div>
                    <div>
                      <p className="text-muted mb-0"><small>Kennitala:<strong className="pl-2">{req?.company_ssn}</strong></small></p>
                    </div>
                    <div>
                      <p className="text-muted mb-0"><small>Skilaboð:<strong className="pl-2">{req?.message}</strong></small></p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </Container>
    </>
  )
}

function Form({handleSubmit}: FormikProps<FormValues>) {
  return (
    <form onSubmit={handleSubmit}>
      <div className="d-flex justify-content-between mb-5">
        <h1 className="h2">Sækja um aðgang fyrirtækis</h1>
        <Building size={30} className="text-dark" />
      </div>

      <div className="mb-4">
        <Field name="company_name" type="text" label="Nafn fyrirtækis" className="mb-3" />
        <Field name="company_ssn" type="text" label="Kennitala fyrirtækis" className="mb-3" />
        <Field name="message" type="textarea" label="Skilaboð" className="mb-3" />
      </div>

      <button className="btn btn-primary w-100" type="submit">Sækja um</button>
    </form>
  )
}
